import { TransparentAccountListType } from "../components/widgets/TransparentAccountList/types";
import { TransparentAccountDetailType } from "../components/widgets/TransparentAccountDetail/types";
// import { ArticleListType } from "js/components/widgets/ArticleList/types";

const TransparentAccountListDummyData: TransparentAccountListType = {
  api: "http://localhost:3131/api/transparent-list",
  baseUrl: "xyz",
  query: "hledany_vyraz",
  items: [
    {
      id: 1,
      perex:
        "TesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttestTesttesttest",
      title: "NejkulatoulinkatejsiKulickaNeCelemSvete",
      url: "#",
      target: null,
    },
    {
      id: 2,
      perex: "Test test test",
      title: "Test test test",
      url: "#",
      target: null,
    },
    {
      id: 3,
      perex: "Test test test",
      title: "Test test test",
      url: "#",
      target: null,
    },
    {
      id: 4,
      perex: "Test test test",
      title: "Test test test",
      url: "#",
      target: null,
    },
    {
      id: 5,
      perex: "Test test test",
      title: "Test test test",
      url: "#",
      target: null,
    },
  ],
  cultureCode: "cs-CZ",
  localization: {
    "transparentAccountList/button": "Načíst další",
    "transparentAccountList/errorMessage":
      "Účty se nepodařilo načíst, Zvolený účet není dostupný, vyberte si ze seznamu níže.",
  },
  pagination: {
    currentPage: 1,
    pagesCount: 5,
    rowsCount: 47,
    rowsOnPage: 10,
  },
};

const TransparentAccountDetailDummyData: TransparentAccountDetailType = {
  title: "Všechny platby",
  balance: {
    amount: "6 507,50 CZK",
    date: "zůstatek k 2. 11. 2021 7:04",
  },
  api: "http://localhost:3131/api/transparent-detail",
  query: "account_id",
  maxVisibleDays: 9999,
  items: [
    {
      id: 1,
      date: "12. 12.",
      info: {
        title: "Consueq Invsvestment Ma",
        transparentAccountInfo: "Adam Majercik, Dar pro nadace",
        additionalInfo: "VS: 25085, KS: 25085, SS: 25085",
      },
      amount: {
        value: "10 000,00 CZK",
        type: "income",
      },
    },
    {
      id: 2,
      date: "21. 11.",
      info: {
        title: "Odchozí platba",
        transparentAccountInfo: "Doplňující informace o transparentní účtu",
      },
      amount: {
        value: "- 10 000,00 CZK",
        type: "expense",
      },
    },
    {
      id: 3,
      date: "14. 10.",
      info: {
        title: 'Položka "C" (1 řádek v tabulce)',
      },
      amount: {
        value: "10 000,00 CZK",
        type: "income",
      },
    },
    {
      id: 4,
      date: "13. 12.",
      year: "2020",
      info: {
        title: "Odchozí platba",
        transparentAccountInfo: "Doplňující informace o transparentním účtu",
      },
      amount: {
        value: "- 10 000,00 CZK",
        type: "expense",
      },
    },
  ],
  cultureCode: "cs-CZ",
  localization: {
    "transparentAccountDetail/button": "Načíst další",
  },
  pagination: {
    currentPage: 1,
    pagesCount: 5,
    rowsCount: 47,
    rowsOnPage: 10,
  },
};

// const ArticleListTypeDummyData: ArticleListType = {
//   title: "Všechny platby",
//   balance: {
//     amount: "6 507,50 CZK",
//     date: "zůstatek k 2. 11. 2021 7:04",
//   },
//   api: "http://localhost:3131/api/transparent-detail",
//   query: "account_id",
//   maxVisibleDays: 9999,
//   items: [
//     {
//       id: 1,
//       info: {
//         title: "Consueq Invsvestment Ma",
//         transparentAccountInfo: "Adam Majercik, Dar pro nadace",
//         additionalInfo: "VS: 25085, KS: 25085, SS: 25085",
//       },
//       amount: {
//         value: "10 000,00 CZK",
//         type: "income",
//       },
//     },
//   ],
//   localization: {
//     "listOfArticlesCategory/button": "Načíst další",
//   },
//   pagination: {
//     currentPage: 1,
//     pagesCount: 5,
//     rowsCount: 47,
//     rowsOnPage: 10,
//   },
// };

const setDummyWidgetsData = (): void => {
  if (window?.WIDGETS_CONFIG) return;

  window.WIDGETS_CONFIG = {
    TransparentAccountList: TransparentAccountListDummyData,
    TransparentAccountDetail: TransparentAccountDetailDummyData,
    // ArticleList: ArticleListTypeDummyData,
  };
};

export default setDummyWidgetsData;
